
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic08 as ObiHydraulic08Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-08.js';
 
 
 

 
 export const ObiHydraulic08 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-08',
   elementClass: ObiHydraulic08Element,
   events: {
     
   }
  });
 
 